import React from "react";
import {getCallToken_calls_token} from "./types/getCallToken";

export interface OAuthState {
    token?: getCallToken_calls_token;
    setToken: (token: getCallToken_calls_token) => void;
}

export const OAuthContext = React.createContext<OAuthState>({} as any);

export default class OAuthProvider extends React.Component<React.PropsWithChildren<{}>, OAuthState> {

    setToken = (token: getCallToken_calls_token) => this.setState({...this.state, token});

    state: OAuthState = {
        setToken: this.setToken
    };

    render() {
        return <OAuthContext.Provider value={this.state}>
            {this.props.children}
        </OAuthContext.Provider>;
    }
}
